<div>
    <div class="actions">
      <button (click)="backPage()" class="btn-action">
        <fa-icon [icon]="['fas', 'arrow-circle-left']" class="fa-thin"></fa-icon>
         Back
      </button>
      <button (click)="addCamera()" class="btn-action">
        <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
         Add Camera
      </button>
    </div>
   
    <div class="container-table">
      <div class="top-header">
        <h3>Cameras Info</h3>
        <p>Camera Details As On 20-10-2024</p>
      </div>
      <div>
        <div class="tab-head">
          <div class="search-bar">
            <div>
              <!-- <form  (ngSubmit)="vehicleSearch()">
                <input type="text" [(ngModel)]="searchText" name='searchText' id="searchText" placeholder="Search">
                <button type="submit" style="width: 40px; height: 40px; border-radius: 50%; border: none; background: rgb(37, 139, 229); cursor: pointer;" hidden>
                  <fa-icon [icon]="['fas', 'magnifying-glass']" class="fa-thin" style="color: rgb(228, 235, 237);font-size: 20px;"></fa-icon>
                </button>
              </form> -->
              <app-generic-search
                [apiUrl]="'cameras/search_suggestion'"
                [resultsApiUrl]="'cameras/'"
                [method]="'GET'"
                [searchParamName]="'q'"
                [pageSize]="10"
                [minChars]="2"
                (resultsFetched)="onResults($event)">
              </app-generic-search>
            </div>
          </div>
          <button (click)="exportToExcel()" class="export-button">
            <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
            EXPORT EXCEL
          </button>
        </div>
        <div class="responsive-table-wrapper">
          <table>
            <thead>
                <tr>
                <th>S.No</th>
                <th>Camera ESN</th>
                <th>Organization</th>
                <th>Direction</th>
                <th>Created At</th>
                <th>Description</th>
                <th>Status</th>
                <th>Action Items</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let record of cameraData let i = index ">
                  <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td> 
                  <td class="table-actions-cell">
                    <span class="camera-esn-badge">{{ record.camera_esn }}</span>
                      <app-copy-button [value]="record.camera_esn" copyTitle="Copy Camera ESN"></app-copy-button>
                  </td>
                  <td>{{ record.organization}}</td>
                  <td>{{ record.direction }}</td>
                  <td>{{ record.created_at | date:'dd-MM-yyyy  hh:mm a' }}</td>
                  <td>
                    <div class="text-clip" (click)="openReason(record.description)">
                      {{ record.description }}
                    </div>
                  </td>
                  <td>
                    <span class="status-pill" [class.active]="record.is_active" [class.inactive]="!record.is_active">
                      {{ record.is_active ? 'Enabled' : 'Disabled' }}
                    </span>
                  </td>
                  <td class="table-actions-cell">
                  <label *ngIf="isSuperUser" class="toggle-switch" [title]="record.is_active ? 'Disable' : 'Enable'">
                    <input type="checkbox" [checked]="record.is_active" (change)="toggleCameraStatus(record, $event)" [disabled]="record._toggling" />
                    <span class="toggle-slider"></span>
                  </label>
                  <button class="action-button bt-edit" (click)="updateCamera(record.id)" title="Edit">
                    <span>
                      <fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                  <button class="action-button bt-delete" (click)="openConfirmationDialog(record.id)" title="Delete">
                    <span>
                      <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                </td>
                
                </tr>
            </tbody>
          </table>
          <div class="footer">
            <div class="total-records">Total Records: {{ totalRecords }}</div>
            <div class="pagination-controls">
              <label for="recordsPerPage">Records per page </label>
              <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()" >
                  <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
              </select>
              <span>{{ currentPage }} / {{ totalPages }}</span>
              <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
                <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
              </button>
              <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
                <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showConfirmationDialog" class="confirmation-modal">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" stroke="#6A5ACD" stroke-width="2" fill="none"/>
        <path d="M9 12l2 2 4-4" stroke="#FFFFFF" stroke-width="2"/>
        </svg> -->
         <i class="bi bi-exclamation-triangle warning-icon"></i>
        <h3>Are You Sure?</h3>
      </div>
      <div class="modal-body">
        <p>Do you want to permanently Delete this Camera ? Confirm your choice below!</p>
      </div>
      <div class="modal-footer">
        <button (click)="confirmDelete()" class="confirm-btn modal-red">Yes, Proceed</button>
        <button (click)="closeConfirmationDialog()" class="cancel-btn cancel-btn-green">Cancel</button>
      </div>
  </div>
  </div>

  <!-- Modal for showing reason -->
  <div *ngIf="showReason" class="confirmation-modal">
    <div class="modal-content">
      <div class="close">
        <span  (click)="closeReason()">
          <fa-icon [icon]="['fas', 'circle-xmark']" class="fa-thin"></fa-icon>
        </span>
      </div>
      <div class="mod-text">
        <p>{{reason}}</p>
      </div>
    </div>
  </div>
